/** TrailerWeightsSlot — three weight inputs in a slate card. */
import { Input } from "@/components/ui/input";
import { Field } from "../_shared";
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function TrailerWeightsSlot({ values, set }) {
  const lbl = useSlotLabel("qa.trailer-weights");
  return (
    <div className="rounded-md border bg-slate-50 p-3 space-y-2">
      <div className="text-xs uppercase tracking-wider text-slate-500 font-medium">
        {lbl("section_title", "Trailer weights (tonnes)")}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <Field label={lbl("load", "Load (with pallets)")}>
          <Input type="number" step="0.1" min={0}
                 value={values.weight_load_with_pallets}
                 onChange={(e) => set("weight_load_with_pallets", e.target.value)}
                 data-testid="booking-weight-load" />
        </Field>
        <Field label={lbl("trailer_1", "Trailer #1")}>
          <Input type="number" step="0.1" min={0}
                 value={values.weight_trailer_1}
                 onChange={(e) => set("weight_trailer_1", e.target.value)}
                 data-testid="booking-weight-t1" />
        </Field>
        <Field label={lbl("trailer_2", "Trailer #2")}>
          <Input type="number" step="0.1" min={0}
                 value={values.weight_trailer_2}
                 onChange={(e) => set("weight_trailer_2", e.target.value)}
                 data-testid="booking-weight-t2" />
        </Field>
      </div>
    </div>
  );
}
